import { render } from "./addOrEditDialog.vue?vue&type=template&id=64a843e8&scoped=true&ts=true"
import script from "./addOrEditDialog.vue?vue&type=script&lang=ts"
export * from "./addOrEditDialog.vue?vue&type=script&lang=ts"

import "./addOrEditDialog.vue?vue&type=style&index=0&id=64a843e8&lang=scss&scoped=true"

import exportComponent from "F:\\工作\\project\\kaola\\kaola-project-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64a843e8"]])

export default __exports__